<template lang="pug">
    include ../../../media/pug/mixins.pug
    +b.SECTION.modal-content
        +b.table
            +e.list._header
                +e.item
                +e.item Сегодня
                +e.item Месяц
            +e.UL.list(v-for="item in apiInfo")
                +e.item #[b {{ item.name }}]
                +e.item(v-html="`<b>${item.today[0]}</b> из ${item.today[1]}`")
                +e.item(v-html="`<b>${item.month[0]}</b> из ${item.month[1]}`")

</template>
<script>
export default {
    data() {
        return {
            apiInfo: [
                {
                    name: 'Limit',
                    today: [0, 100],
                    month: [0, 100]
                },
                {
                    name: 'Local',
                    today: [0, 100],
                    month: [0, 100]
                },
                {
                    name: 'OEK',
                    today: [0, 100],
                    month: [0, 100]
                },
                {
                    name: 'Open',
                    today: [0, 100],
                    month: [0, 100]
                },
                {
                    name: 'Orphan',
                    today: [0, 100],
                    month: [0, 100]
                },
                {
                    name: 'Rate',
                    today: [0, 100],
                    month: [0, 100]
                },
                {
                    name: 'Stop',
                    today: [0, 100],
                    month: [0, 100]
                },
                {
                    name: 'View',
                    today: [0, 100],
                    month: [0, 100]
                },
                {
                    name: 'Viewrate',
                    today: [0, 100],
                    month: [0, 100]
                }
            ]
        };
    }
};
</script>
